// extracted by mini-css-extract-plugin
export default {"Blackberry":"#333D47","Bronze":"#E8C776","surcharge":"Gc45ef0","valueBackground":"G3a3972"};